import { ATIL_MADDELER } from './email-mask-tarayici';
/**
 * YAPISAL İNDİRGEME — "@'nin İKİ YANI BİTİŞİK" ŞARTININ KALDIRILMASI.
 *
 * BEŞ DALGA, TEK KÖK (QA, 16.09.2026). Dört tur boyunca kapatılmaya çalışılan
 * şey bir ÇÖZÜCÜ KARA LİSTESİYDİ ve tanım gereği kapanmadı: beşinci dalga
 * yirmi dakikada bulundu ve dördü panelde GÖZLE okunuyordu:
 *   `ali<!---->@ornek.com` · `<span>ali</span>@ornek.com` ·
 *   `<ali@(yorum)ornek.com>` · `ali at ornek dot com`
 * Dördünün de kodlamayla ilgisi YOK. Ortak kök şuydu: desen `YEREL@ALAN`
 * dizisini BİTİŞİK görmek zorundaydı; araya ne sokulursa (HTML yorumu, HTML
 * etiketi, RFC 5322 yorumu, boşluk) desen düşüyordu. Yeni bir çözücü satırı
 * bunu ENGELLEMEZ, çünkü sorun kodlama değil YAPI.
 *
 * BU DOSYANIN YAPTIĞI: adresi üç YAPISAL parçaya ayırır ve parçalar arasında
 * yalnız ATIL maddenin bulunabileceğini söyler.
 *
 *   YEREL   —  ara (ATIL)  —  AT  —  ara (ATIL)  —  ALAN
 *
 *  · ATIL KÜME KAPALIDIR ve sayılabilir: HTML yorumu · işaretleme bildirimi
 *    (CDATA/işlem yönergesi/DOCTYPE) · HTML/XML etiketi · RFC 5322 yorumu
 *    (İÇ İÇE dahil) · ANSI CSI dizisi · boşluk. "Atıl" tanımı mekanik değil
 *    yapısaldır: bu maddeler adresin parçası DEĞİLDİR, ekranda görünmezler ya
 *    da anlam taşımazlar, yani okuyan insan onları yok sayarak adresi okur.
 *    Kaçış biçimleri sonsuzdur; atıl madde sınıfı değildir.
 *  · Atıl madde normalleştirmede ÜÇ KİPTE ele alınır: SÖKÜLÜR (`sok`),
 *    KOŞULSUZ AÇILIR (`ayir`) ya da OCAK BAZINDA karar verilir (`secici`).
 *    Üçü ayrı GÖRÜNÜM olarak koşar; tanımlar `email-mask-atil.ts`tedir. Her
 *    hâlde geriye kalan boşluk kümesi `boslugaIndirge` ile TEK boşluğa çöker,
 *    yani desende yalnız `ARA_ESIGI = 1` kalır.
 *  · ALAN yapısal olarak tanınır: TLD TAŞIYAN simge (`etiket(.etiket)*.tld`),
 *    köşeli ayraçlı IP ya da bitişik hâlde tek etiketli host. Boşluklu
 *    yazımda TLD ZORUNLUDUR — `Error @ line 5` gibi metinlerin yanlış
 *    maskelenmesini engelleyen ayak budur ve kapıda ölçülür.
 *
 * YANLIŞ POZİTİF MALİYETİ ÖLÇÜLDÜ (bkz. `email-mask.spec.ts` 12. ve 15. AYAK):
 * on üç gerçek sağlayıcı biçimi AYNEN döner. Atıl işlemi YALNIZ metinde adres
 * VARKEN çıktıya ulaşır (hiçbir görünüm eşleşme bulmazsa özgün dize döner),
 * yani teşhis kaybı ancak zaten maskelenmiş bir satırda olabilir.
 *
 * MADDE TANIMLARI AYRI DOSYADA (`email-mask-atil.ts`) — dokuzuncu dalgada bu
 * dosya kaynak tavanını (500 satır) aştı. Kamuya açık yüzey burada kalır:
 * çağıranlar ve kapılar `./email-mask-structure` yolunu sürmeye devam eder.
 */
/**
 * ATIL MADDELERİ MADDE MADDE SEÇEREK İŞLER — SÖK · AYIR · SEÇİCİ.
 *
 * SEKİZİNCİ DALGA, KÖK BİLEŞİMDİ (tech-lead, 16.09.2026). Yedinci dalga iki
 * GLOBAL okuma tanımlamıştı: ya HEPSİ sökülür (kanonik) ya HEPSİ ayrılır
 * (atıl-korunmuş). İki atıl tür İÇ İÇE geçtiğinde doğru okuma İKİSİNİN KARIŞIMI
 * olur ve global seçim onu üretemez. Ölçüldü — dokuz bileşimin SEKİZİ sızdı,
 * üçünde adres BÜTÜNÜYLE ham kaldı:
 *   `<!-- <b>qauser8</b>@ornek.com -->`      yorum AÇILMALI, etiket SÖKÜLMELİ
 *   `<!-- qauser8<![CDATA[x]]>@ornek.com -->` yorum AÇILMALI, bildirim SÖKÜLMELİ
 *   `<div title="qauser8<![CDATA[x]]>@o.com">` etiket AÇILMALI, bildirim SÖKÜLMELİ
 * Hepsi sıradan bir HTML hata gövdesinin biçimidir; "iki tür bir arada" kural,
 * istisna değil.
 *
 * Sıra sabittir: etiket sökülmeden yorum çapası kurulamaz.
 *
 * `maddeler` alt kümesi YALNIZ kapı içindir (mutasyon probu): her madde tek tek
 * çıkarılır ve o madde olmadan hangi biçimin GÖZLE okunur kaldığı ölçülür.
 * DARALTMA MADDENİN KENDİSİNE DE GEÇER (ikinci parametre): `secici` kipin ocak
 * kararı içeriği öteki maddelerle de okur ve global listeye bakarsa sökülen
 * maddenin yükünü SESSİZCE telafi eder — telafi eden kapı kör kapıdır.
 */
export function atillariSecerek(metin, ayrilan, maddeler = ATIL_MADDELER, kip = 'ayir') {
    return maddeler.reduce((sonuc, madde) => ayrilan.has(madde.ad)
        ? kip === 'secici'
            ? madde.secici(sonuc, maddeler)
            : madde.ayir(sonuc, maddeler)
        : madde.sok(sonuc, maddeler), metin);
}
/** Seçimli okumanın İKİ UÇ NOKTASI — adları `MASKE_GORUNUMLERI`nde geçer. */
export const HICBIRI_AYRILMAZ = new Set();
export function tumAtilAdlari(maddeler = ATIL_MADDELER) {
    return new Set(maddeler.map((madde) => madde.ad));
}
/** Atıl maddeyi söker (seçimin `hiçbiri ayrılmaz` ucu). */
export function atillariSok(metin, maddeler = ATIL_MADDELER) {
    return atillariSecerek(metin, HICBIRI_AYRILMAZ, maddeler);
}
/**
 * Atıl maddeyi SİLMEZ, ayırıcıya indirger — taşıdığı metin KORUNUR (bkz. `ayir`).
 * Seçimin `hepsi ayrılır` ucu.
 */
export function atillariAyiriciYap(metin, maddeler = ATIL_MADDELER) {
    return atillariSecerek(metin, tumAtilAdlari(maddeler), maddeler);
}
/* ==========================================================================
 * ATIL MADDE TANIMLARI — AYRI DOSYALARDA (`email-mask-atil.ts` tip ve ocak
 * kararı · `email-mask-tarayici.ts` desenler ve madde listesi).
 * BOŞLUĞA İNDİRGEME de oradadır: ocak kararı onu kendi ölçütünde kullanır ve
 * burada kalsaydı dosyalar birbirini çevrimsel olarak import ederdi.
 * ========================================================================== */
export { AT_BITISIK_BOSLUK, boslugaIndirge, } from './email-mask-atil';
export { ATIL_HIZLI_YOLLARI, ATIL_MADDELER, JETON_MADDELER, atilMaddeler, } from './email-mask-tarayici';
/* ==========================================================================
 * ADRES DESENİ — AYRI DOSYADA (`email-mask-desen.ts`).
 *
 * Kamuya açık yüzey burada kalır: çağıranlar ve kapılar
 * `./email-mask-structure` yolunu sürmeye devam eder.
 * ========================================================================== */
export { ARA_ESIGI, YAPISAL_VARSAYILAN, adresDeseni, adresVarMi, } from './email-mask-desen';
//# sourceMappingURL=email-mask-structure.js.map